import { clsx } from "clsx";
import { ReactNode } from "react";
import { useIntl } from "react-intl";
import styles from "./Toast.module.scss";

interface ToastProps {
  onClose?: () => void;
  children?: ReactNode;
  type?: "success" | "error";
  title?: ReactNode;
  className?: string;
  // don't show success/error icon on left, default show icon
  noIcon?: boolean;
  // optional content in start col, e.g. an image
  startCol?: ReactNode;
}

export default function Toast({
  onClose,
  children,
  type,
  title,
  className,
  noIcon = false,
  startCol,
}: ToastProps) {
  const intl = useIntl();

  const content = (
    <>
      {title && <div className="vst-toast-component-title">{title}</div>}
      {children}
    </>
  );

  return (
    <div
      className={clsx(
        "vst-toast",
        type && `vst-toast-variant-${type}`,
        noIcon && "vst-toast-option-no-icon",
        className
      )}
    >
      {startCol ? (
        <div className={styles.columnContent}>
          <div>{startCol}</div>
          <div className={styles.columnText}>{content}</div>
        </div>
      ) : (
        <>{content}</>
      )}

      <button
        className="vst-toast-component-close-button"
        onClick={onClose}
        aria-label={intl.formatMessage({ defaultMessage: "Close" })}
        data-tooltip-content={intl.formatMessage({ defaultMessage: "Close" })}
        data-tooltip-position-strategy="fixed"
      ></button>
    </div>
  );
}
